import React, { useState, useEffect } from 'react';
import {Constraint} from "@aperza/validator";
import FormFieldUtil from "../../util/FormFieldUtil";

const createFieldMap = (items, enableComment) => {

  let fieldMap = {};
  items.forEach((item, index) => {
    if (item.plainId) {
      let fieldName = `field_${item.plainId}`;
      fieldMap[fieldName] = {
        fieldId: +item.plainId,
        fieldName,
        value: '',
        errorId: undefined,
        invalid: false,
        inputValue: {},
        constraint: item.answerRequired?Constraint.required:undefined,
      }
    }
  });

  if (enableComment) {
    let fieldName = `field_comment`;
    fieldMap[fieldName] = {
      fieldId: fieldName,
      fieldName,
      value: '',
      errorId: undefined,
      invalid: false,
      inputValue: {},
      constraint: {
        length: {
          minimum: 0,
          maximum: 1000,
          message: '^comment_rangelength',
        },
      },
    }
  }

  return fieldMap;
};

const useSurveyFieldMap = (items, enableComment) => {

  const [fieldMap, setFieldMap] = useState(createFieldMap(items, enableComment));

  const initFieldMap = (items, enableComment) => {
    setFieldMap(createFieldMap(items, enableComment));
  };

  const updateFieldValue = (field, value, inputValue) => {
    if (field) {
      let clonedFieldMap = Object.assign({}, fieldMap);
      if (clonedFieldMap[field]) {
        clonedFieldMap[field].value = value;
        clonedFieldMap[field].inputValue[value] = inputValue;
        setFieldMap(clonedFieldMap);
      }
      validateFieldMap();
    }
  };

  const validateFieldMap = () => {
    let fields = Object.keys(fieldMap).map(key => {
      let field = fieldMap[key];
      return field;
    });
    let updatedFields = FormFieldUtil.validateFields(fields);
    if (updatedFields) {
      let updatedFieldMap = {};
      updatedFields.forEach(updatedField => {
        updatedFieldMap[updatedField.fieldName] = updatedField;
      });
      setFieldMap(updatedFieldMap);
      return updatedFields;
    }
    return undefined;
  };

  return {
    fieldMap,
    initFieldMap,
    updateFieldValue,
    validateFieldMap,
  };
};

export default useSurveyFieldMap;
